module.exports = __webpack_public_path__ + "media/student_lending_center/psl-logo-ab138647.png";